import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax

mapboxgl.accessToken =
  "pk.eyJ1IjoiYnJpbmdtZXRoZWRlYXRoc3RhciIsImEiOiJjbDVjeXZ1d3UwbWNxM2NsMW1ubW00bDdsIn0.WRNZ6KfVCFFh_3tP_4sF2g";

export default function Map() {
  const venues = useSelector((state) => Object.values(state.venues));
  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    // initialize map only once
    if (map.current) {
      return;
    }

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/bringmethedeathstar/cl5pji78c00cy14nvasc98zts",
      interactive: false,
      attributionControl: false,
    });

    const bounds = new mapboxgl.LngLatBounds();

    // Add markers
    venues.forEach(({ loc }) => {
      const coords = [loc.lng, loc.lat];

      new mapboxgl.Marker().setLngLat(coords).addTo(map.current);

      bounds.extend(coords);
    });

    map.current.fitBounds(bounds, {
      padding: 50,
    });
  });

  return (
    <div>
      <div ref={mapContainer} className="w-full aspect-video" />
    </div>
  );
}

// export default function Map({ onMount, onMountProps }) {
//   const venues = useSelector((state) => Object.values(state.venues));
//   const [map, setMap] = useState();
//   const ref = useRef();

//   useEffect(() => {
//     const onLoad = () => {
//       const bounds = new window.google.maps.LatLngBounds();
//       const map = new window.google.maps.Map(ref.current, {
//         center: { lat: 48, lng: 8 },
//         mapId: "d4df209557c2da53",
//         disableDefaultUI: true,
//         zoom: 5,
//       });

//       venues.forEach(({ loc }) => {
//         bounds.extend(new window.google.maps.LatLng(loc.lat, loc.lng));

//         new window.google.maps.Marker({
//           position: loc,
//           map: map,
//         });
//       });

//       map.fitBounds(bounds);

//       return setMap(map);
//     };

//     if (!window.google) {
//       const script = document.createElement(`script`);
//       script.src =
//         "https://maps.googleapis.com/maps/api/js?key=AIzaSyD7YREkiNfbEvwld_Nk7y0xXun9slGw9BE";

//       document.head.append(script);

//       script.addEventListener(`load`, onLoad);

//       return () => script.removeEventListener(`load`, onLoad);
//     } else {
//       onLoad();
//     }
//   }, [venues]);

//   if (map && typeof onMount === `function`) {
//     onMount(map, onMountProps);
//   }

//   return <div className="w-full aspect-video" {...{ ref }} />;
// }
